import React from "react";

const DownloadIcon = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="23"
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M20.8322 20.0205H3.67188M17.9722 10.4869L12.2521 16.2071M12.2521 16.2071L6.53194 10.4869M12.2521 16.2071V2.86011"
                stroke="#9195A9"
                strokeWidth="1.90671"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default DownloadIcon;
